function StatCard({ icon, title, main, badge, badgeColor, sub }) {
  return (
    <div className="bg-white border rounded-xl p-4 shadow-sm hover:shadow-md transition">
      <div className="flex items-center justify-between mb-3">
        <div className="text-slate-600">{icon}</div>
      </div>
      <p className="text-slate-500 text-xs uppercase font-semibold tracking-wide mb-1">
        {title}
      </p>
      <h3 className="text-xl font-bold text-slate-800 mb-2">{main}</h3>
      <div className="flex items-center gap-2">
        <span
          className={`px-2 py-0.5 text-xs font-medium rounded-full ${badgeColor}`}
        >
          {badge}
        </span>
        <span className="text-slate-500 text-xs">{sub}</span>
      </div>
    </div>
  );
}

export default StatCard;
